<template>
  <div>
    <NavTop>
    </Navtop>
    <!-- 内容 -->
    <div class=" box content">
      <div class="box_r">
        <p>网站正在建设中........</p>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data () {
    return {}
  },
  mounted () {

  },
  methods: {}
}
</script>
<style lang="less" scoped>
.box {
  padding-bottom: 40px;
  display: flex;
  justify-content: space-between;
  .box_r{
    width: 100% !important;
    line-height: 482px;
    p{
      font-size: 41px;
      text-align: center;
      color: #b7aeae;
    }
  }
}

.content {
  width: 1200px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/views/copyright/copyright.vue